import styled from 'styled-components'
import { Box, Text } from '@usap/uicomponents'
import { Heading1 } from '../../common/heading'

const TABLET_LANDSCAPE = 'tablet-landscape'

export const BannerImage = styled.img`
  height: 220px;
  object-fit: cover;
  object-position: center;
  width: 100%;
  max-width: 1920px;

  ${props => props.theme.mediaQuery.up(TABLET_LANDSCAPE)} {
    object-position: left;
  }
`

export const BannerHeading = styled(Heading1)`
  color: #ffffff;
  margin-bottom: 10px;
  font-size: 26px;

  ${props => props.theme.mediaQuery.up(TABLET_LANDSCAPE)} {
    font-size: 30px;
  }
`

export const SeoBanner = styled(Box)`
  height: 220px;
  position: relative;
  margin-top: 16px;

  ${props => props.theme.mediaQuery.up(TABLET_LANDSCAPE)} {
    margin: 0;
  }
`

export const BannerPicture = styled.picture`
  background-color: #949398;
  display: flex;
  justify-content: center;
  height: 220px;
  width: 100%;
`

export const BannerTextContainer = styled(Box)`
  width: 100%;
  padding-left: 10px;
  position: absolute;
  top: 78px;

  > div {
    width: 100%;
    max-width: 1248px;
    margin: 0 auto;
  }
`

export const BannerText = styled(Text)`
  font-size: 18px;
  color: #FFFFFF;
`
